import AssistantAgentsAPI from 'dashboard/api/assistant/agents';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'AssistantAgent',
  API: AssistantAgentsAPI,
});
